import styles from "./AppNav.module.css";
import { Breadcrumb, type BreadcrumbItem } from "./Breadcrumb";
import { Logo } from "./Logo";
import { Navbar } from "./Navbar";
import { ProfileMenu } from "./ProfileMenu";

const MARKETING_SITE = "https://www.shobdo.ai";

type AppNavProps = {
  trail?: BreadcrumbItem[];
  onSignOut?: () => void;
  userName?: string | null;
  userAvatar?: string | null;
};

export const storeTrail = (
  store: { id: string; name: string } | null,
  current: string,
): BreadcrumbItem[] => [
  { label: "Your stores", href: "/stores" },
  ...(store ? [{ label: store.name, href: `/stores/${store.id}` }] : []),
  { label: current },
];

export const AppNav = ({ trail, onSignOut, userName, userAvatar }: AppNavProps) => (
  <Navbar
    brand={
      <a
        href={MARKETING_SITE}
        aria-label="Shobdo — go to www.shobdo.ai"
        style={{ display: "inline-flex", textDecoration: "none" }}
      >
        <span className={styles.brandFull}>
          <Logo />
        </span>
        <span className={styles.brandMark}>
          <Logo variant="mark" />
        </span>
      </a>
    }
    sectionLabel={trail && trail.length > 0 ? <Breadcrumb items={trail} /> : undefined}
    avatar={<ProfileMenu userName={userName} userAvatar={userAvatar} onSignOut={onSignOut} />}
  />
);
